import { FC, SVGAttributes } from 'react';

const Close: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        d="M18.636 6.63601C18.9875 6.28453 18.9875 5.71469 18.636 5.36321C18.2845 5.01174 17.7147 5.01174 17.3632 5.36321L11.9996 10.7268L6.63601 5.36321C6.28453 5.01174 5.71469 5.01174 5.36321 5.36321C5.01174 5.71469 5.01174 6.28453 5.36321 6.63601L10.7268 11.9996L5.36321 17.3632C5.01174 17.7147 5.01174 18.2845 5.36321 18.636C5.71469 18.9875 6.28453 18.9875 6.63601 18.636L11.9996 13.2724L17.3632 18.636C17.7147 18.9875 18.2845 18.9875 18.636 18.636C18.9875 18.2845 18.9875 17.7147 18.636 17.3632L13.2724 11.9996L18.636 6.63601Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Close;
